var cov_1sikawsurt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Gap/styles/index.js",
      hash = "6ce0e78840ebbccfad286cee5053b6222242c74d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Gap/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 24
        },
        end: {
          line: 5,
          column: 50
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var GapLess = {};
import genaration from '../../utils/classname';
export var gapClass = (cov_1sikawsurt.s[0]++, genaration(GapLess, 'gap'));